import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "sr-only",
  role: "status",
  "aria-live": "polite"
}

import { computed, nextTick, ref } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from '@shell/composables/useI18n';
import Pinned from '@shell/components/nav/Pinned.vue';
import { pinnableCluster } from '@shell/utils/cluster';
import { isMac, shortcutLabel } from '@shell/utils/platform';

interface Props {
  cluster: any;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ClusterPinControl',
  props: {
    cluster: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const store = useStore();
const { t } = useI18n(store);

const pin = ref<any>(null);
const announcement = ref('');

const pinnable = computed(() => pinnableCluster(props.cluster));

// Bound `.anywhere`: a filter box holding the caret is no reason not to pin the cluster on screen. The
// switcher flyout takes the same combo but silences shortcuts while it is open, so the two never clash.
const shortcutKeys = { windows: ['alt', 'p'], mac: ['meta', 'shift', 'p'] };
const shortcut = computed(() => shortcutLabel(isMac ? ['⌘', 'Shift', 'P'] : ['Alt', 'P']));
const ariaShortcut = isMac ? 'Meta+Shift+P' : 'Alt+P';

const tooltip = computed(() => {
  if (!pinnable.value) {
    return null;
  }

  return t(pinnable.value.pinned ? 'nav.header.unpinCluster' : 'nav.header.pinCluster', { shortcut: shortcut.value });
});

function onShortcut() {
  pin.value?.toggle();
}

// Silent while the pin has focus: `aria-pressed` already says it, and announcing would say it twice.
function announce(cluster: { label: string }, pinned: boolean) {
  if (pin.value?.$el === document.activeElement) {
    return;
  }

  const message = t(pinned ? 'nav.switcher.aria.pinnedCluster' : 'nav.switcher.aria.unpinnedCluster', { cluster: cluster.label });

  announcement.value = '';
  nextTick(() => {
    announcement.value = message;
  });
}

__expose({
  pinnable, tooltip, shortcutKeys, shortcut, ariaShortcut, announcement, onShortcut, announce
});

return (_ctx: any,_cache: any) => {
  const _directive_clean_tooltip = _resolveDirective("clean-tooltip")!
  const _directive_shortkey = _resolveDirective("shortkey")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (pinnable.value)
      ? _withDirectives((_openBlock(), _createBlock(Pinned, {
          key: 0,
          ref_key: "pin",
          ref: pin,
          cluster: pinnable.value,
          "tab-order": 0,
          class: "cluster-pin",
          "aria-keyshortcuts": _unref(ariaShortcut),
          onShortkey: onShortcut,
          onPinned: _cache[0] || (_cache[0] = ($event: any) => (announce($event, true))),
          onUnpinned: _cache[1] || (_cache[1] = ($event: any) => (announce($event, false)))
        }, null, 8, ["cluster", "aria-keyshortcuts"])), [
          [_directive_clean_tooltip, tooltip.value],
          [
            _directive_shortkey,
            shortcutKeys,
            void 0,
            { anywhere: true }
          ]
        ])
      : _createCommentVNode("", true),
    _cache[2] || (_cache[2] = _createTextVNode()),
    _createElementVNode("div", _hoisted_1, _toDisplayString(announcement.value), 1)
  ], 64))
}
}

})